<ng-container
  *ngIf="data && data[0] || (editorialAthleteBiography && editorialAthleteBiography.data && editorialAthleteBiography.data.length > 0) ">
  <app-athlete-biography-insights [model]="model" [forCarousel]="true"></app-athlete-biography-insights>

  <div *ngIf="getInformationOfBiography(2)?.Value || editorialAthleteBiography.data.length > 0"
    class="editorial-wrapper">
    <h2 #info>{{'About' | transloco}}</h2>
    <div class="editorial-info" *ngIf="editorialAthleteBiography.data">
      <app-see-more [elementToScroll]="info" [maxHeightPx]="350">
        <ng-container *ngFor="let information of editorialAthleteBiography.data">
          <section #editorial class="editorial-content">
            <article [innerHTML]="information.body"></article>
            <div *ngIf="information.date && information.date != '' && information.author">
              <address class="editorial-author">
                ({{'last_update_biography' | transloco}}
                <ng-container *ngIf="information.author">{{'by' | transloco}}</ng-container>
                {{' '}}
                <a>{{information.author}}</a>
                {{'on_date_editorial' | transloco}}
                <time pubdate [attr.datetime]="information.date| date :'dd MMMM yyyy'">
                  {{information.date| date :'dd MMMM yyyy'}}.
                </time>
                )
              </address>

            </div>
          </section>
        </ng-container>
      </app-see-more>
    </div>
  </div>
  <div class="api-editorial-info" *ngIf="getInformationOfBiography(2)?.Value as description">
    <ng-container *ngIf="editorialAthleteBiography.data.length == 0">
      <pre [innerHTML]="description"></pre>
    </ng-container>
  </div>
  <div myMatchHeight="description__block" class="description">
    <div *ngIf="getInformationOfBiography(12)?.Value as occupation" class="description__block">
      <div>
        <p class="title">{{'OCCUPATION' | transloco}}:</p>
        <div class="info">
          <p style="font-weight: bold">{{occupation}}</p>
        </div>
      </div>
    </div>
    <div *ngIf="getInformationOfBiography(-1)?.Value as lives" class="description__block">
      <div>
        <p class="title">{{'LIVES' | transloco}}:</p>
        <div class="info">
          <p style="font-weight: bold">{{lives}}</p>
          <lib-country-flag *ngIf="getInformationOfBiography(-2)?.Value as NOC" [name]="getCountryName(NOC)"
            [id]="NOC"></lib-country-flag>
        </div>
      </div>
    </div>
    <div *ngIf="getInformationOfBiography(46)?.Value as comes" class="description__block">
      <div>
        <p class="title">{{'comes_from' | transloco}}:</p>
        <div class="info">
          <p style="font-weight: bold">{{comes}}</p>
          <lib-country-flag *ngIf="getInformationOfBiography(47)?.Value as NOC" [name]="getCountryName(NOC)"
            [id]="NOC"></lib-country-flag>
        </div>
      </div>
    </div>
    <div *ngIf="getInformationOfBiography(31)?.Value as coach" class="description__block">
      <div>
        <p class="title">{{'COACH' | transloco}}:</p>
        <div class="info">
          <p style="font-weight: bold">{{coach}}</p>
          <lib-country-flag *ngIf="getInformationOfBiography(32)?.Value as NOC" [name]="getCountryName(NOC)"
            [id]="NOC"></lib-country-flag>
        </div>
      </div>
    </div>
    <div *ngIf="getInformationOfBiography(25)?.Value as started" class="description__block">
      <div>
        <p class="title">{{'started_archery' | transloco}}:</p>
        <div class="info">
          <p style="font-weight: bold">{{started}}</p>
        </div>
      </div>
    </div>
    <div *ngIf="getInformationOfBiography(9)?.Value as debut" class="description__block">
      <div>
        <p class="title">{{'international_debut' | transloco}}:</p>
        <div class="info">
          <p style="font-weight: bold">{{debut}}</p>
        </div>
      </div>
    </div>
    <div *ngIf="getInformationOfBiography(21)?.Value as education" class="description__block">
      <div>
        <p class="title">{{'EDUCATION' | transloco}}:</p>
        <div class="info">
          <p style="font-weight: bold">{{education}}</p>
          <p style="font-weight: bold" *ngIf="getInformationOfBiography(22)?.Value as where">
            {{where}}
          </p>
          <p style="font-weight: bold" *ngIf="getInformationOfBiography(24)?.Value as city">
            {{city}}
          </p>
          <lib-country-flag *ngIf="getInformationOfBiography(23)?.Value as NOC" [name]="getCountryName(NOC)"
            [id]="NOC"></lib-country-flag>
        </div>
      </div>
    </div>
    <a href="https://extranet.worldarchery.sport/biographies/PrintBiography.php?WaId={{(athleteId|async)}}"
      target="_blank">

      <div class="description__block">
        <div class="external-pdf">
          <div class="title">
            <img lazyLoad src="../../../../modules/custom/wa_angular/app/assets/icons/docx-icon.png">
            <p>{{'biography_highlights' | transloco}}</p>
          </div>
          <div class="info">

            <img lazyLoad style="float: right;
        margin-right: 20px;" src="../../../../modules/custom/wa_angular/app/assets/icons/external_grey.png">
          </div>

        </div>
      </div>
    </a>
  </div>
  <!-- TO DO add when insights ready.
  <a href="{{'https://extranet.worldarchery.sport/biographies/PrintBiography.php?WaId='+(athleteId|async).toString()}}" class="biography-link">
  Biography Hightlights (PDF)
  </a> -->
  <app-athlete-medals [athlete]="data[0]"></app-athlete-medals>

  <app-athlete-olympic-panel *ngIf="common_service.athleteDetailStore.olympic_panel.length > 0"
    [olympic_data]="common_service.athleteDetailStore.olympic_panel" [title]="'Olympic Games' | transloco"
    [short_title]="'Olympic' | transloco">
  </app-athlete-olympic-panel>

  <app-athlete-olympic-panel *ngIf="common_service.athleteDetailStore.paralympic_panel.length > 0"
    [olympic_data]="common_service.athleteDetailStore.paralympic_panel" [title]="'Paralympic Games' | transloco"
    [short_title]="'Paralympic' | transloco">
  </app-athlete-olympic-panel>

  <app-athlete-olympic-panel *ngIf="common_service.athleteDetailStore.youth_olympic_panel.length > 0"
    [olympic_data]="common_service.athleteDetailStore.youth_olympic_panel" [title]="'Youth Olympic Games' | transloco"
    [short_title]="'Youth Olympic' | transloco">
  </app-athlete-olympic-panel>

  <app-wa-table headerMessage="Positions" *ngIf="data[0] && data[0].Positions && getPositions().length > 0"
    [isSortableFunc]="sortClass" [showCondition]="true" [headers]="headers()" [isDataLoading]="loading"
    [areMoreData]="areMoreData()" (loadMore)="loadMore()" [data]="getPositions()" (headerClick)="changeSort($event)">
    <ng-template [extraClass]="['wa-table__cell--fit-right']" app-column let-position>

      <div>
        <ng-container
          *ngIf="isArrayYears(position.FunYears) !== false && position.FunStart == null && position.FunEnd == null; else date">{{isArrayYears(position.FunYears)}}</ng-container>
        <ng-template #date>
          <ng-container *ngIf="position.FunStart">
            {{getDateStartPosition(position.FunStart)}}
          </ng-container>
          -
          <ng-container *ngIf="position.FunEnd">{{getDateEndPosition(position.FunEnd)}}</ng-container>
        </ng-template>

      </div>

    </ng-template>
    <ng-template [extraClass]="['wa-table__cell--fit-right']" app-column let-position>
      <div>{{position.FunName}}</div>

    </ng-template>
    <ng-template [extraClass]="['wa-table__cell--fit-left']" app-column let-position>
      <div>
        {{getOrganisationFromPosition(position)}}
        <lib-country-flag *ngIf="position.type !== 'WA' && position.type !== 'WAAm'"
          [id]="position.type"></lib-country-flag>
      </div>

    </ng-template>
  </app-wa-table>

  <!-- Use for debug and developing to see all.

  <app-athlete-biography-insights class="insight-wrapper" [model]="model"></app-athlete-biography-insights> -->
</ng-container>
